import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { AnalysisType } from "@/common/types/analysis";

export async function analysisBreakList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/break/list${queryString}`,
  );
}

export async function analysisBreakCreate(account_id: string, payload: any) {
  return await clientAxios.post(
    `account/${account_id}/analysis/break/create`,
    payload,
  );
}

export async function analysisBreakShow(account_id: string, break_id: string) {
  return await clientAxios.get(
    `account/${account_id}/analysis/break/${break_id}/show`,
  );
}

export async function analysisBreakPatch(
  account_id: string,
  break_id: string,
  payload: Partial<AnalysisType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/analysis/break/${break_id}/patch`,
    {
      payload,
    },
  );
}

export async function analysisBreakStop(account_id: string, break_id: string) {
  return await clientAxios.post(
    `account/${account_id}/analysis/break/${break_id}/stop`,
    {},
  );
}
